export default "__VITE_ASSET__JB05$YJO__"